import { render, staticRenderFns } from "./DependencyItem.vue?vue&type=template&id=fe86d416&"
import script from "./DependencyItem.vue?vue&type=script&lang=js&"
export * from "./DependencyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports